var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import AppProviders from './AppProviders';
import Router from './Router';
import { AppVersionMismatchError } from '../api/request';
import { blue } from '@mui/material/colors';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  position: relative;\n"], ["\n  height: 100%;\n  position: relative;\n"])));
var UpdateAlert = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: white;\n  background-color: ", ";\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: no-wrap;\n  align-items: center;\n  position: fixed;\n  bottom: 0px;\n  min-height: 30px;\n  padding: 10px 20px;\n  width: calc(100% - 40px);\n  z-index: 10000;\n"], ["\n  color: white;\n  background-color: ", ";\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: no-wrap;\n  align-items: center;\n  position: fixed;\n  bottom: 0px;\n  min-height: 30px;\n  padding: 10px 20px;\n  width: calc(100% - 40px);\n  z-index: 10000;\n"])), blue[500]);
var Root = function () {
    var _a = React.useState(), updatableVersion = _a[0], setUpdatableVersion = _a[1];
    var t = useTranslation().t;
    var handleUnhandledRejection = React.useCallback(function (event) {
        if (event.reason instanceof AppVersionMismatchError) {
            setUpdatableVersion(event.reason.version);
            setTimeout(function () {
                location.reload();
            }, 5000);
        }
    }, []);
    React.useEffect(function () {
        window.addEventListener('unhandledrejection', handleUnhandledRejection);
        return function () {
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        };
    }, [handleUnhandledRejection]);
    return (React.createElement(Wrapper, null,
        updatableVersion && (React.createElement(UpdateAlert, null,
            React.createElement("div", null, t('messages.updateRequired', { version: updatableVersion })),
            React.createElement(Button, { size: "small", variant: "contained", onClick: function () { return location.reload(); } }, t('buttons.updateNow')))),
        React.createElement(AppProviders, null,
            React.createElement(Router, null))));
};
export default Root;
var templateObject_1, templateObject_2;
